import Seo from "../Seo/Seo";
import BgSlider from "../Hero/bg";
import ContactForm from "../Forms/contact";

export default function Contact() {
    return <>
        <Seo
            title="Contact | Provence Paie - Demande de devis et accompagnement RH"
            description="Contactez Provence Paie pour une étude de vos besoins paie et RH. Une équipe dédiée aux cabinets d'expertise comptable en Provence vous répond rapidement."
            pathname="/Contact"
        />
        <BgSlider
            title="Contactez-nous!"
            subtitle="Provence Paie"
        />
        <ContactForm />
    </>
}